import { TFunction } from "i18next";

interface SessionOccupiedError {
  role: string;
  userInfo: string;
  editionInfo: string;
  overlapStartDate: string;
  overlapEndDate: string;
  classroomInfo: string;
}

export const isSessionOccupiedError = (message?: string): boolean => {
  if (!message) return false;
  try {
    const parts = message.split("\n");
    return parts.map(part => {
      const parsed = JSON.parse(part);
      return typeof parsed === "object" && "role" in parsed;
    }).every(Boolean);
  } catch {
    return false;
  }
};

export const formatSessionOccupiedError = (
  message: string,
  t: TFunction<"translation", undefined>
): string => {
  try {
    const parsedMessage: SessionOccupiedError[] = message
      .split("\n")
      .filter((line: string) => line.trim())
      .map((line: string) => JSON.parse(line));

    const translatedMessages: string[] = [];

    parsedMessage.forEach((message: SessionOccupiedError) => {
      const translatedMessage = t(
        "session-occupied-teacher-or-tutor-or-learner",
        {
          classroomInfo: message.classroomInfo,
          editionInfo: message.editionInfo,
          interpolation: { escapeValue: false },
          overlapEndDate: message.overlapEndDate,
          overlapStartDate: message.overlapStartDate,
          role:
            message.role.toLowerCase() === "teacher"
              ? t("roles-digited.teacher")
              : message.role.toLowerCase() === "student"
                ? "Learner"
                : message.role.split("")[0].toUpperCase() +
                  message.role.slice(1).toLowerCase(),
          userInfo: message.userInfo
        }
      );
      translatedMessages.push(translatedMessage);
    });

    if (parsedMessage.length === 0)
      return t("session-occupied-parsing-error");
    return translatedMessages.join("\n");
  } catch (error) {
    console.error("Error during parsing message", error);
    return String(message);
  }
};
